<template>
  <div>
    <custom-actions>
      <template #header>
      </template>
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width account-form"
        label-width="100px">

        <el-form-item label="供应商名称" prop="userName">
          <el-input v-model="searchForm.userName" placeholder="请输入供应商名称"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="160" :show-overflow-tooltip="true" label="供应商名称" prop="userName"></el-table-column>
        <el-table-column min-width="130" label="可用保证金" prop="depositAfterChange"></el-table-column>
        <el-table-column min-width="140" label="充值保证金" prop="depositChange"></el-table-column>
        <el-table-column min-width="120" label="总保证金" prop="depositAllChange"></el-table-column>
        <el-table-column min-width="160" label="可用货款" prop="goodsAfterChange"></el-table-column>
        <el-table-column min-width="160" label="货款总额" prop="goodsChange"></el-table-column>

        <el-table-column width="150" label="操作" fixed="right">
          <template v-slot="{ row }">

            <el-button type="text" @click="
              $router.push('/ycuserBond/detail?userId=' + row.userId)
              ">详情</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>

    <!-- <el-dialog v-model="show" title="Shipping address">
      <el-form>
        <el-form-item prop="" label=""></el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="show = false">Cancel</el-button>
          <el-button type="primary" @click="show = false"> Confirm </el-button>
        </span>
      </template>
    </el-dialog> -->
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
export default {
  name: 'userBond',
  mixins: [keepAlive],
  data() {
    return {
      tableData: [],

      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        userName: ''
      },
      userList: []
    }
  },
  created() {
    this.loadUser()
    this.loadData()
  },
  computed: {},
  methods: {
    loadUser() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, { userType: '4' }).then(res => {
        this.userList = res.list || []
      })
    },

    loadData() {
      const params = {
        page: this.page,
        ...this.searchForm
      }
      console.log('params', params)
      this.$axios
        .get(this.$apis.yxcUserBond.selectYxcUserDepositByList, {
          params: params
        })
        .then(res => {
          this.tableData = res.list
          this.total = res.total
        })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.formData.resetFields()
      this.onSearch()
    }

  }
}
</script>

<style scoped lang="scss"></style>
